import { useEffect, useState } from "react";

export function useIsTelegramWebApp() {
  const [isTelegramWebApp, setIsTelegramWebApp] = useState(false);

  useEffect(() => {
    // Check if window.Telegram.WebApp exists
    try {
      if (window?.Telegram && window?.Telegram?.WebApp) {
        setIsTelegramWebApp(true);
        window?.Telegram?.WebApp?.init(); // Initialize the WebApp if inside Telegram
      }
    } catch (err) {
      console.error("err telegram web", err);
    }
  }, []);

  return isTelegramWebApp;
}
